import * as React from 'react';
import { StyleRulesCallback, WithStyles } from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';
import { Divider } from '@material-ui/core';
import { AnsweredQuestionDto, AnsweredQuestionnaireDto } from '../../../pages/answeredQuestionnaireTypes';
import { QuestionType } from '../../../pages/questionTypes';
import AnsweredMultipleChoiceQuestion from './questionTypes/AnsweredMultipleChoiceQuestion';
import AnsweredMultipleColumnQuestion from './questionTypes/AnsweredMultipleColumnQuestion';
import AnsweredTextQuestion from './questionTypes/AnsweredTextQuestion';
import { observer } from 'mobx-react';
import { observable } from 'mobx';
import { CommentDto, emptyComment } from './commentTypes';
import { addOrUpdateComment } from './commentApi';
import OnFinishedTextField from '../../OnFinishedTextField';
import { translation } from '../../../i18n';
import QuestionHeader from '../common/QuestionHeader';
import { Grid } from '@material-ui/core';

interface Props {
  answeredQuestion: AnsweredQuestionDto,
  questionnaireId: number,
  enableComment: boolean,
  updateQuestionnaire: (updatedQuestionnaire: AnsweredQuestionnaireDto) => void
}

type LocalStyles = 'root' | 'question' | 'questionSection' | 'questionBody' | 'commentSection';

const localStyles: StyleRulesCallback<LocalStyles> = theme => ({
  root: {
    flexGrow: 1,
  },
  question: {
    overflowX: 'scroll',
    overflowY: 'hidden'
  },
  questionSection: {
    display: 'flex',
    flexDirection: 'row'
  },
  questionBody: {
    display: 'flex',
    flexDirection: 'column'
  },
  commentSection: {
    width: '100%',
    paddingBottom: theme.spacing.unit,
  }
});

type PropsWithStyle = WithStyles<LocalStyles> & Props;

@observer
class AnsweredQuestion extends React.Component<PropsWithStyle> {

  @observable private comment: CommentDto = emptyComment();

  constructor(props: PropsWithStyle) {
    super(props);

    if (this.props.answeredQuestion.comment == null) {
      this.comment = emptyComment();
    } else {
      this.comment = this.props.answeredQuestion.comment
    }
  }

  public render() {
    const {classes} = this.props;
    return (
      <div className={this.props.classes.root}>
        <Grid container={true}>
          <Grid item={true} sm={12} md={4}>
            <QuestionHeader question={this.props.answeredQuestion.question}
                            description={this.props.answeredQuestion.description}/>
          </Grid>
          <Grid item={true} sm={12} md={true} className={classes.question}>
            <div className={classes.questionBody}>
              <div className={classes.questionSection}>
                {this.renderTable()}
              </div>
              {
                this.props.enableComment &&
                <div className={classes.commentSection}>
                  <Divider key={this.props.answeredQuestion.id + 'divider'}/>
                  <OnFinishedTextField
                    fullWidth={true}
                    label={translation.t('comment.comment')}
                    value={this.comment.comment}
                    onFinished={this.handleTextChange}
                    multiline={true}/>
                </div>
              }
            </div>
          </Grid>
        </Grid>
      </div>

    )
  }

  private renderTable() {
    switch (this.props.answeredQuestion.questionType) {
      case QuestionType.MULTIPLE_CHOICE: {
        return (
          <AnsweredMultipleChoiceQuestion enableComment={this.props.enableComment} key={this.props.answeredQuestion.id}
                                          answeredQuestion={this.props.answeredQuestion}/>
        )
      }
      case QuestionType.MULTIPLE_COLUMNS: {
        return (
          <AnsweredMultipleColumnQuestion enableComment={this.props.enableComment} key={this.props.answeredQuestion.id}
                                          answeredQuestion={this.props.answeredQuestion}/>
        )
      }
      case QuestionType.TEXT: {
        return (
          <AnsweredTextQuestion enableComment={this.props.enableComment} key={this.props.answeredQuestion.id}
                                answeredQuestion={this.props.answeredQuestion}/>
        )
      }
    }
  }

  private handleTextChange = (value: string) => {
    this.comment.comment = value;
    addOrUpdateComment(this.comment, this.props.answeredQuestion.id, this.props.questionnaireId).then(
      data => this.props.updateQuestionnaire(data)
    )
  };

}

export default withStyles(localStyles)(AnsweredQuestion);
